import { mappingIframeGames, IFRAME_GAME_URLS } from '~/configs/page-url'
import { useGames } from '~/composables/games/use-games'
import { useLogin } from '~/composables/account/use-login'
import { useModal } from '~/composables/common/use-modal'
import { ModalCollection } from '~/constants'

export function useNavigate() {
  const { isMobile } = useDevice()
  const router = useRouter()
  const { getPlayGameUrl, getIframeGameMapGameApi, openModalMaintainAthenaGames, isMaintainAthenaGames } = useGames()
  const { isLogged, showModalLogin } = useLogin()
  const { openModal } = useModal()
  async function navigate(url: string, loginRequired: boolean = false, isNewTab: boolean = false): Promise<void> {
    if (loginRequired && !isLogged.value) {
      showModalLogin()
      return
    }
    if (isMaintainAthenaGames(url.replaceAll('/', ''))) {
      openModalMaintainAthenaGames()
      return
    }
    const splitUrl = url.split('?')
    if (isMobile && (url in mappingIframeGames || splitUrl[0] in mappingIframeGames)) {
      isNewTab = true
    }
    if (!url) {
      return
    }
    // Check version games C sports
    if (url === IFRAME_GAME_URLS.A_SPORTS && isMobile) {
      openModal(ModalCollection.DISPLAYED_VERSION)
      return
    }
    void openNewTab(url, isNewTab, isMobile)
  }
  async function openNewTab(
    url: string,
    isNewTab: boolean,
    isDeviceMobile: boolean = isMobile
  ): Promise<boolean | undefined> {
    let newTab: Window | null
    if (isNewTab) {
      newTab = window.open('', '_blank')
      if (isValidURL(url) && newTab) {
        newTab.location.href = url
        return
      }
      const gameApi = getIframeGameMapGameApi(url)
      if (!gameApi && newTab) {
        newTab.location.href = url
        return
      }
      const urlResponse = (await getPlayGameUrl(getIframeGameMapGameApi(url), isDeviceMobile))?.content
      if (urlResponse && newTab) {
        newTab.location.href = urlResponse
      } else if (newTab) {
        newTab.close()
      }
      return
    }
    void router.push(url)
  }

  return {
    navigate,
    openNewTab
  }
}
